import SocialEntityRepository from '@/shared/http/repositories/socialProject/social-entity'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import NewRegister from '@/components/layout/NewRegister/newRegister.vue'
import SocialEntity from '@/shared/models/socialEntity'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'EditarEntidadeSocial',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [NewRegister.name]: NewRegister
  },

  data: () => ({
    placeholder: 'Nome',
    title: 'Entidade Social',
    socialEntity: new SocialEntity(),
    isNew: false
  }),

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Entidades Sociais',
            href: this.$router.resolve({ name: 'SocialEntity' }).href
          },
          {
            text: 'Editar Entidade Social',
            active: true
          }
        ]
      }
    }
  },

  created() {
    this.getById()
  },

  methods: {
    getById() {
      loading.push()
      SocialEntityRepository.GetById(this.$route.params.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.socialEntity = res.data.data
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar entidade social', 'ERRO')
        })
    },

    update(socialEntity) {
      loading.push()
      SocialEntityRepository.Update(socialEntity)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          loading.pop()
          toast.success('Entidade Social editada com sucesso', 'EDITAR ENTIDADE SOCIAL')
          Promise.resolve()
          return this.$router.replace({ name: 'SocialEntity' })
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao editar entidade social', 'ERRO')
        })
    }
  }
}
